(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best_seller"] && !Shopify.designMode) return;
  try {
    
    // Desktop carousel
    var desktopSwiper = new Swiper(".best-seller-desktop-slider", {
      slidesPerView: 4,
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: ".best-seller-next-btn",
        prevEl: ".best-seller-prev-btn",
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });

    // Mobile carousel
    var mobileSwiper = new Swiper(".best-seller-slider", {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: ".best-seller-mobile-next-btn",
        prevEl: ".best-seller-mobile-prev-btn",
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Wait for Swiper to exist (timeout after ~5s)
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  // store instances here
  window._collectionSliders = window._collectionSliders || {};

  function initCollectionSliderForSection(sectionEl) {
    if (!sectionEl) return;

    // Use data-section-id if present, otherwise generate key from element index
    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || sectionEl.getAttribute('data-id') || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.collection-slider'), sectionEl);

    // If already initialized, destroy first
    if (window._collectionSliders[key] && window._collectionSliders[key].destroy) {
      try {
        window._collectionSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._collectionSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.custom-collection-slider-swiper');
    if (!swiperEl) {
      console.warn('Swiper container not found in section', key);
      return;
    }

    var nextBtn = sectionEl.querySelector('.custom-collection-slider-next');
    var prevBtn = sectionEl.querySelector('.custom-collection-slider-prev');
    var scrollbarEl = sectionEl.querySelector('.custom-collection-scrollbar');

    // Build config - exact same as product slider
    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      centeredSlides: false,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    // For navigation, pass DOM elements (scoped to this section)
    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._collectionSliders[key] = instance;
      // optional: expose instance for debugging
      console.debug('Initialized collection slider', key, instance);
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.collection-slider').forEach(function (el) {
      initCollectionSliderForSection(el);
    });
  }

  // Boot sequence
  waitForSwiper(function () {
    // initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor events (reinit / unload)
    document.addEventListener('shopify:section:load', function (e) {
      // e.detail.sectionId exists when Editor loads a single section
      // re-init everything to be safe; or you can target e.detail.sectionId
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      // destroy instance for removed section
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._collectionSliders && window._collectionSliders[sid]) {
        try { window._collectionSliders[sid].destroy(true, true); } catch (err) { /* ignore */ }
        delete window._collectionSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".collection-slider-swiper", {
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      
      navigation: {
        nextEl: ".collection-slider-next",
        prevEl: ".collection-slider-prev",
      },
      centeredSlides: false, 
       breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".collection-slider-swiper", {
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      
      navigation: {
        nextEl: ".collection-slider-next",
        prevEl: ".collection-slider-prev",
      },
      centeredSlides: false, 
       breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection filtering functionality
  document.addEventListener('DOMContentLoaded', function() {
    const resultsList = document.querySelector('results-list');
    const productGrid = document.querySelector('.product-grid-container');
    
    if (!resultsList || !productGrid) return;

    // Listen for collection filter changes
    document.addEventListener('collection-filter-change', function(event) {
      const { collectionHandle, collectionTitle } = event.detail;
      
      // Update URL without page reload
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('collection', collectionHandle);
      window.history.pushState({}, '', newUrl);
      
      // Filter products
      filterProductsByCollection(collectionHandle, collectionTitle);
    });

    function filterProductsByCollection(collectionHandle, collectionTitle) {
      const productItems = productGrid.querySelectorAll('.product-grid__item');
      
      // Handle "Show All" case
      if (collectionHandle === 'all') {
        productItems.forEach(item => {
          item.style.display = '';
          item.classList.remove('filtered-out');
        });
        return;
      }
      
      const loadingIndicator = createLoadingIndicator();
      
      // Show loading
      productGrid.appendChild(loadingIndicator);
      
      // Hide all products initially
      productItems.forEach(item => {
        item.style.display = 'none';
        item.classList.add('filtered-out');
      });

      // Fetch products for the selected collection
      fetchCollectionProducts(collectionHandle)
        .then(products => {
          // Remove loading indicator
          if (loadingIndicator.parentNode) {
            loadingIndicator.parentNode.removeChild(loadingIndicator);
          }
          
          // Show products that match the collection
          products.forEach(product => {
            const productItem = productGrid.querySelector(`[data-product-id="${product.id}"]`);
            if (productItem) {
              productItem.style.display = '';
              productItem.classList.remove('filtered-out');
            }
          });
          
          // Update results count
        })
        .catch(error => {
          console.error('Error filtering products:', error);
          // Show all products on error
          productItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('filtered-out');
          });
        });
    }

    function fetchCollectionProducts(collectionHandle) {
      return fetch(`/collections/${collectionHandle}/products.json`)
        .then(response => response.json())
        .then(data => data.products || []);
    }

    function createLoadingIndicator() {
      const indicator = document.createElement('div');
      indicator.className = 'collection-filter-loading';
      indicator.innerHTML = `
        <div style="text-align: center; padding: 2rem;">
          <div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          <p style="margin-top: 1rem;">Loading products...</p>
        </div>
      `;
      return indicator;
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(event) {
      const urlParams = new URLSearchParams(window.location.search);
      const collectionParam = urlParams.get('collection');
      
      if (collectionParam) {
        // Find and trigger the corresponding filter tab
        const filterTab = document.querySelector(`[data-collection-handle="${collectionParam}"]`);
        if (filterTab) {
          filterTab.click();
        }
      } else {
        // Show all products and activate "Show All" tab
        const productItems = productGrid.querySelectorAll('.product-grid__item');
        productItems.forEach(item => {
          item.style.display = '';
          item.classList.remove('filtered-out');
        });
        
        // Remove active class from all filter tabs
        document.querySelectorAll('.collection-filter-tab').forEach(tab => {
          tab.classList.remove('active');
        });
        
        // Activate "Show All" tab
        const showAllTab = document.querySelector('.show-all-tab');
        if (showAllTab) {
          showAllTab.classList.add('active');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-list"] && !Shopify.designMode) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  
    // Collection filtering functionality
    document.addEventListener('DOMContentLoaded', function() {
      const resultsList = document.querySelector('results-list');
      const productGrid = document.querySelector('.product-grid-container');
      
      if (!resultsList || !productGrid) return;
  
      // Listen for collection filter changes
      document.addEventListener('collection-filter-change', function(event) {
        const { collectionHandle, collectionTitle } = event.detail;
        
        // Update URL without page reload
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('collection', collectionHandle);
        window.history.pushState({}, '', newUrl);
        
        // Filter products
        filterProductsByCollection(collectionHandle, collectionTitle);
      });
  
      function filterProductsByCollection(collectionHandle, collectionTitle) {
        const productItems = productGrid.querySelectorAll('.product-grid__item');
        
        // Handle "Show All" case
        if (collectionHandle === 'all') {
          productItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('filtered-out');
          });
          return;
        }
        
        const loadingIndicator = createLoadingIndicator();
        
        // Show loading
        productGrid.appendChild(loadingIndicator);
        
        // Hide all products initially
        productItems.forEach(item => {
          item.style.display = 'none';
          item.classList.add('filtered-out');
        });
  
        // Fetch products for the selected collection
        fetchCollectionProducts(collectionHandle)
          .then(products => {
            // Remove loading indicator
            if (loadingIndicator.parentNode) {
              loadingIndicator.parentNode.removeChild(loadingIndicator);
            }
            
            // Show products that match the collection
            products.forEach(product => {
              const productItem = productGrid.querySelector(`[data-product-id="${product.id}"]`);
              if (productItem) {
                productItem.style.display = '';
                productItem.classList.remove('filtered-out');
              }
            });
            
            // Update results count
          })
          .catch(error => {
            console.error('Error filtering products:', error);
            // Show all products on error
            productItems.forEach(item => {
              item.style.display = '';
              item.classList.remove('filtered-out');
            });
          });
      }
  
      function fetchCollectionProducts(collectionHandle) {
        return fetch(`/collections/${collectionHandle}/products.json`)
          .then(response => response.json())
          .then(data => data.products || []);
      }
  
      function createLoadingIndicator() {
        const indicator = document.createElement('div');
        indicator.className = 'collection-filter-loading';
        indicator.innerHTML = `
          <div style="text-align: center; padding: 2rem;">
            <div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
            <p style="margin-top: 1rem;">Loading products...</p>
          </div>
        `;
        return indicator;
      }
  
      // Handle browser back/forward buttons
      window.addEventListener('popstate', function(event) {
        const urlParams = new URLSearchParams(window.location.search);
        const collectionParam = urlParams.get('collection');
        
        if (collectionParam) {
          // Find and trigger the corresponding filter tab
          const filterTab = document.querySelector(`[data-collection-handle="${collectionParam}"]`);
          if (filterTab) {
            filterTab.click();
          }
        } else {
          // Show all products and activate "Show All" tab
          const productItems = productGrid.querySelectorAll('.product-grid__item');
          productItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('filtered-out');
          });
          
          // Remove active class from all filter tabs
          document.querySelectorAll('.collection-filter-tab').forEach(tab => {
            tab.classList.remove('active');
          });
          
          // Activate "Show All" tab
          const showAllTab = document.querySelector('.show-all-tab');
          if (showAllTab) {
            showAllTab.classList.add('active');
          }
        }
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Wait for Swiper to exist (timeout after ~5s)
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  // store instances here
  window._productSliders = window._productSliders || {};

  function initSliderForSection(sectionEl) {
    if (!sectionEl) return;

    // Use data-section-id if present, otherwise generate key from element index
    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || sectionEl.getAttribute('data-id') || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.product-new-slider'), sectionEl);

    // If already initialized, destroy first
    if (window._productSliders[key] && window._productSliders[key].destroy) {
      try {
        window._productSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._productSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.product-new-slider-swiper');
    if (!swiperEl) {
      console.warn('Swiper container not found in section', key);
      return;
    }

    var nextBtn = sectionEl.querySelector('.swiper-button-next');
    var prevBtn = sectionEl.querySelector('.swiper-button-prev');
    var scrollbarEl = sectionEl.querySelector('.swiper-scrollbar');

    // Build config
    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    // For navigation, pass DOM elements (scoped to this section)
    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._productSliders[key] = instance;
      // optional: expose instance for debugging
      console.debug('Initialized product slider', key, instance);
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.product-new-slider').forEach(function (el) {
      initSliderForSection(el);
    });
  }

  // Boot sequence
  waitForSwiper(function () {
    // initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor events (reinit / unload)
    document.addEventListener('shopify:section:load', function (e) {
      // e.detail.sectionId exists when Editor loads a single section
      // re-init everything to be safe; or you can target e.detail.sectionId
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      // destroy instance for removed section
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._productSliders && window._productSliders[sid]) {
        try { window._productSliders[sid].destroy(true, true); } catch (err) { /* ignore */ }
        delete window._productSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valentine-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Wait for Swiper to exist (timeout after ~5s)
  function waitForSwiper(cb) {
    var attempts = 0;
    var id = setInterval(function () {
      attempts++;
      if (window.Swiper) {
        clearInterval(id);
        cb();
      } else if (attempts > 50) {
        clearInterval(id);
        console.error('Swiper not found. Make sure the Swiper script is loaded before this section script.');
      }
    }, 100);
  }

  // store instances here
  window._collectionSliders = window._collectionSliders || {};

  function initCollectionSliderForSection(sectionEl) {
    if (!sectionEl) return;

    // Use data-section-id if present, otherwise generate key from element index
    var sectionId = sectionEl.dataset.sectionId || sectionEl.dataset.id || sectionEl.getAttribute('data-id') || null;
    var key = sectionId || Array.prototype.indexOf.call(document.querySelectorAll('.valentine-collection-slider'), sectionEl);

    // If already initialized, destroy first
    if (window._collectionSliders[key] && window._collectionSliders[key].destroy) {
      try {
        window._collectionSliders[key].destroy(true, true);
      } catch (err) {
        console.warn('Error destroying previous swiper instance:', err);
      }
      delete window._collectionSliders[key];
    }

    var swiperEl = sectionEl.querySelector('.valentine-collection-slider-swiper');
    if (!swiperEl) {
      console.warn('Swiper container not found in section', key);
      return;
    }

    var nextBtn = sectionEl.querySelector('.valentine-collection-slider-next');
    var prevBtn = sectionEl.querySelector('.valentine-collection-slider-prev');
    var scrollbarEl = sectionEl.querySelector('.valentine-collection-scrollbar');

    // Build config - exact same as homepage (max 4 slides)
    var config = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      centeredSlides: false,
      watchOverflow: true,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 16 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 16 }
      }
    };

    if (scrollbarEl) {
      config.scrollbar = { el: scrollbarEl, draggable: true };
    }

    // For navigation, pass DOM elements (scoped to this section)
    if (nextBtn && prevBtn) {
      config.navigation = { nextEl: nextBtn, prevEl: prevBtn };
    }

    try {
      var instance = new Swiper(swiperEl, config);
      window._collectionSliders[key] = instance;
      console.debug('Initialized collection slider', key, instance);
    } catch (err) {
      console.error('Failed to initialize Swiper for section', key, err);
    }
  }

  function initAll() {
    document.querySelectorAll('.valentine-collection-slider').forEach(function (el) {
      initCollectionSliderForSection(el);
    });
  }

  // Boot sequence
  waitForSwiper(function () {
    // initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor events (reinit / unload)
    document.addEventListener('shopify:section:load', function (e) {
      initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      // destroy instance for removed section
      var sid = e.detail && e.detail.sectionId;
      if (sid && window._collectionSliders && window._collectionSliders[sid]) {
        try { window._collectionSliders[sid].destroy(true, true); } catch (err) { /* ignore */ }
        delete window._collectionSliders[sid];
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
